import styled from 'styled-components';

const inputHoverColor = 'bec3c5';
const inputTextColor = '#282c2d';
const bgc = '#f5f6f7';
const blue = '#003876';

const SearchbarContent = styled.section`
  transform: translateY(5px);
  margin-left: auto;
  margin-right: 20px;
  justify-self: center;
  align-self: center;
  display: flex;
  flex-direction: row;

  @media (max-width: 875px) {
    margin-right: 30px !important ;
  }
`;

const Searchbar = styled.input`
  height: 35px;
  width: 175px;
  outline: 0;
  border: 0;
  background-color: ${bgc};
  margin-left: auto;
  color: #7d8589 !important;
  padding-left: 12px;
  border-radius: 0 3px 3px 0;
  font-family: inherit;

  &::content {
    padding-left: 10px;
    color: #7d8589 !important;
  }

  &::placeholder {
    font-weight: 400 !important;
  }

  @media (max-width: 815px) {
    width: 135px !important ;
  }
`;

const IconContainer = styled.div`
  height: 37px;
  width: 40px;
  background-color: ${blue};
  z-index: 2;
  outline: 0;
  border: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px 0 0 3px;
  transform: translateX(5px);
`;

const InputLogin = styled.input`
  height: 40px;
  outline: 0;
  border: 0;
  margin: 10px;
  padding: 5px;
  padding-left: 40px;
  font-size: 18px;
  background-color: ${bgc};
  color: ${inputTextColor};
  border-radius: 6px;
  width: 84%;
  text-indent: 10px;
  border: solid 1px #eee;
  font-family: 'Montserrat';
  font-weight: 300;

  &::-webkit-input-placeholder,
  &::-webkit-input-placeholder {
    color: ${inputHoverColor};
  }
  &:-moz-placeholder,
  input:-moz-placeholder {
    color: ${inputHoverColor};
  }
  &::-moz-placeholder,
  &::-moz-placeholder {
    color: ${inputHoverColor};
  }
  &:-ms-input-placeholder,
  &:-ms-input-placeholder {
    color: ${inputHoverColor};
  }
  &:focus ~ label,
  input:valid ~ label {
  }
  :not(:placeholder-shown) ~ label {
  }
  ::placeholder {
    padding-left: 0px;
  }
`;

export { Searchbar, IconContainer, SearchbarContent, InputLogin };
